import React from 'react';
import HintPopoverMenu from "../../../../core/gd-ui/hint-popover/hint-popover-menu";
import NavigationSection from "../../../../core/model2/navigation/navigation-section";
import {findDOMNode} from "react-dom";
import Popover from "../../../../core/gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../core/gd-components/gd-popover/popover-position";
import {PopoverAttachmentType} from "../../../../core/gd-components/gd-popover/@const";
import MainMenu_MoreButton from "../../../menu/menu-items/menu-more";

type Props = {
    hint?       : string,
    section?    : NavigationSection
}

type State = {
    showPopover: boolean
}

export default class Navigation_ButtonHint extends React.Component<Props, State> {

    public refHint: React.RefObject<HintPopoverMenu> = React.createRef<HintPopoverMenu>()

    private showDelay       : number = 600
    private hideDelay       : number = 100

    hideHint = () => {
        this.refHint.current?.hide()
    }

    constructor(props: Props) {
        super(props);

        this.state = {
            showPopover: false
        };
    }


    public parentEl         : any
    public debounceShowHint : any
    public debounceHideHint : any

    private preventHideHint : boolean = false




    componentDidMount() {
        // this.parentEl = findDOMNode(this.props.parent);
        this.parentEl = findDOMNode(this)?.parentNode;

        this.parentEl.addEventListener("mouseenter", this.show);
        this.parentEl.addEventListener("mouseleave", this.hide);
        this.parentEl.addEventListener("wheel", this.hide);

        this.debounceShowHint = this.showDelay === 0 ? this._showPopover : _.debounce(this._showPopover, this.showDelay);
        this.debounceHideHint = this.hideDelay === 0 ? this._hidePopover : _.debounce(this._hidePopover, this.hideDelay);
    }

    componentWillUnmount() {

        if (this.showDelay !== 0 && this.debounceShowHint) this.debounceShowHint.cancel();
        if (this.hideDelay !== 0 && this.debounceHideHint) this.debounceHideHint.cancel();

        this.parentEl.removeEventListener("mouseenter", this.show);
        this.parentEl.removeEventListener("mouseleave", this.hide);
        this.parentEl.removeEventListener("wheel", this.hide);
    }

    show = () => {
        // if (this.props.checkShowHint) {
        //     if (this.props.checkShowHint()) this.debounceShowHint();
        // } else {
            this.debounceShowHint();
        // }
    }

    hide = () => {
        if (this.debounceShowHint) this.debounceShowHint.cancel();
        this.debounceHideHint();
    }

    forceHide = () => {
        this.preventHideHint = false
        this._hidePopover()
    }

    _showPopover = () => {if (!this.state.showPopover)                          this.setState({showPopover: true})}
    _hidePopover = () => {if (this.state.showPopover && !this.preventHideHint)  this.setState({showPopover: false})}

    onMouseEnter = () => {
        if (this.debounceHideHint) this.debounceHideHint.cancel()
    }

    onMouseLeave = () => {
        this.debounceHideHint();
    }

    // onHintClick = () => {
    //     if (this.props.onClick) this.props.onClick();
    //     this._hidePopover();
    // }

    onTogglePopover = (value:boolean) => {
        this.preventHideHint = value
    }

    onClickOutside = (e:any) => {
        if (gd.utils.Dom.findNodeByClassName(e.target, ['ui-menu-more-popover'])) return;

        this.forceHide()
    }

    // setDisplayPosition = async (position:NavigationButtonPosition) => {
    //
    //     navigation_setPositionNew(this.props.section, position)
    //
    // }

    render() {

        if (!this.props.section?.hint && !this.props.hint) {
            return null
        }

        if (!this.state.showPopover) {
            // we need element to find (this)
            return <span className="empty-hint" />
        }

        let attachment, targetAttachment, offset
        let attachmentType  : 'horizontal' | 'vertical'

        const hintType = gd.layout.isTop ? 'bottom' : 'right'

        switch (hintType) {
            case 'bottom':
                attachment          = "top center"
                targetAttachment    = "bottom center"
                attachmentType      = "horizontal"
                offset              = "2 0"
                break

            case 'right':
                attachment          = "middle right"
                targetAttachment    = "middle left"
                attachmentType      = "vertical"
                offset              = "0 3"
                break
        }

        // return (
        //     <HintPopoverMenu hint               = {this.props.section.hint}
        //                      ref                = {this.refHint}
        //         // buttons            = {this.props.buttons}
        //                      buttons            = {this.renderMoreButton}
        //                      showDelay          = {600}
        //                      hideDelay          = {100}    // need 100 otherwise hover hint ne srabativaet
        //                      attachment         = {attachment}
        //                      targetAttachment   = {targetAttachment}
        //                      attachmentType     = {attachmentType}
        //                      offset             = {offset}/>
        // )

        const popoverClasses = Classes("default-type", {
            "gd-ui-hint-popover"            : true, //this.props.color === 'black',
            // "gd-ui-hint-popover-gray"       : this.props.color === 'gray',
            // 'no-click': !this.props.onClick,
            "width-buttons"                 : true,
            multiline                       : false //this.props.multiline
        });

        const hint = this.props.section?.hint || this.props.hint

        const moreOptions : Option[] = this.props.section?.positionOptions || []

        const popoverPosition = new PopoverPosition({
            attachment      : attachment,
            targetAttachment: targetAttachment,
            offset          : offset,
            attachmentType  : attachmentType as PopoverAttachmentType,
        })

        return (
            <Popover popoverClass={popoverClasses}
                     // getTargetFunc={this.props.getTargetFunc ?  this.props.getTargetFunc : ()=> {
                     //     return this.parentEl
                     // }}

                     getTargetFunc={()=> {
                         return this.parentEl
                     }}
                     onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}
                     position={popoverPosition}
                     onClickOutside={this.onClickOutside}
                // onClick={this.onHintClick}  if enabled it kills controls inside
            >

                <div className="flex-row-left-center">
                    <div className="hint-text" >
                        {hint}
                    </div>

                    {(_.size(moreOptions) >0 ) &&
                        <MainMenu_MoreButton className       = "button flex-row-center-center m-r-5"
                                             menuOptions     = {moreOptions}
                                             onTogglePopover = {this.onTogglePopover}/>
                    }

                </div>
            </Popover>
        );


    }










}
